// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pager_pagination__2zvzN","active":"pager_active__1L2Bi"};